export default {
    dockReservations: [],
    dockClipboardReservations: [],
    user: null,
    availableHoursForSelectedDay: [],
    customers: [],
    docks: [],
    docksLoading: false,
    dockTypes: [],
    dockReservationStatuses: [],
    stores: [],
    storesLoading: false
}